import axios from "axios";
import request from "@/utils/request";

let apiURL = 'https://mainnet-beta.api.drift.trade'

export const getTrades = async (account, size, page) => {
  let url = `/drift/v1/trades/userAccounts?userPublicKeys=${account}&marketIndex=&marketType=&targetPageIndex=0&pageSize=${size}`
  const { data } = await request({
    url
  })
  if (data && data.data && data.data.records) {
    let list = data.data.records[0]
    let total = data.data.totalCounts[0]
    return {
      list,
      total
    }
  }
  return {
    list: [],
    total: 0
  }
}
export const getMarkets24h = async () => {
  let url = `${apiURL}/markets24h`
  const { data } = await request({
    url
  })
  let list = data.map(item => {
    return {
      symbol: item.symbol,
      symbolOld: item.symbol,
      marketIndex: item.marketIndex,
      marketType: item.marketType.perp ? 'perp' : 'spot',

      price24hAgo: item.price24hAgo,
      h24Vol: item.quoteVolume,
      h24High: item.priceHigh,
      h24Low: item.priceLow,
    }
  })

  return list
};


